/**
 * @description 查询对象类
 * @author: 菩萨蛮
 * @date 2020/2/12 9:11 下午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */


export default class SearchObj {
  constructor(param, name, value, type = 'input', label) {
    this._type = type;
    this._name = name;
    this._value = value;
    this._param = param;
    this._label = label;
  }

  get tags() {
    let name = this._name;
    if (this._type !== 'date') {
      name = `${this._name}:${this._type !== 'select' ? this._value : this._label}`;
    }
    if (this._type === 'customer') {
      name = `${this._name}:${this._label}`;
    }
    if (this._type === 'user') {
      name = `${this._name}:${this._label}`;
    }
    if (this._type === 'warehouse') {
      name = `${this._name}:${this._label}`;
    }
    if (this._type === 'checkbox') {
      name = `${this._name}:${this._label}`;
    }
    if (this._type === 'radio') {
      name = `${this._name}:${this._label}`;
    }
    if (this._type === 'autocomplete') {
      name = `${this._name}:${this._label}`;
    }


    return {
      name,
      type: this._type,
      value: this._value,
      param: this._param,
      _label: this._label
    };
  }
}
